const MODE_KEY = 'anotequest_storage_mode';
const LOCAL_WORKSPACE_KEY = 'local-workspace';
const DB_NAME = 'anotequest-local-workspace';

export function isLocalMode() {
  return localStorage.getItem(MODE_KEY) === 'local';
}

export function setStorageMode(mode) {
  localStorage.setItem(MODE_KEY, mode === 'local' ? 'local' : 'sync');
}

function openDb() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1);
    request.onupgradeneeded = () => {
      if (!request.result.objectStoreNames.contains('workspaces')) {
        request.result.createObjectStore('workspaces');
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

async function withWorkspaceStore(mode, callback) {
  const db = await openDb();
  try {
    return await new Promise((resolve, reject) => {
      const transaction = db.transaction('workspaces', mode);
      const result = callback(transaction.objectStore('workspaces'));
      transaction.oncomplete = () => resolve(result);
      transaction.onerror = () => reject(transaction.error);
      transaction.onabort = () => reject(transaction.error);
    });
  } finally {
    db.close();
  }
}

export async function loadLocalWorkspace() {
  try {
    return await withWorkspaceStore('readonly', (store) => {
      const request = store.get(LOCAL_WORKSPACE_KEY);
      return new Promise((resolve, reject) => {
        request.onsuccess = () => resolve(request.result || null);
        request.onerror = () => reject(request.error);
      });
    });
  } catch (error) {
    console.warn('Could not load local workspace:', error);
    return null;
  }
}

export async function saveLocalWorkspace(workspace) {
  try {
    await withWorkspaceStore('readwrite', (store) => {
      store.put({ ...workspace, savedAt: Date.now() }, LOCAL_WORKSPACE_KEY);
    });
    return true;
  } catch (error) {
    console.warn('Could not save local workspace:', error);
    return false;
  }
}
